import { render, staticRenderFns } from "./JsonPropertiesField.vue?vue&type=template&id=5ce5cc41&scoped=true&"
import script from "./JsonPropertiesField.vue?vue&type=script&lang=js&"
export * from "./JsonPropertiesField.vue?vue&type=script&lang=js&"
import style0 from "./JsonPropertiesField.vue?vue&type=style&index=0&id=5ce5cc41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce5cc41",
  null
  
)

export default component.exports